import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { useRoute } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { ActivityIndicator, StyleSheet, Text, View } from "react-native";
import RNCarousel from "react-native-looped-carousel";
import { ScrollView } from "react-native-gesture-handler";
import GoldenStar from "@assets/svg/GoldenStar";
import ProfileIcon from "@assets/svg/ProfileIcon";
import { s } from "@utils/metrics_1";
import isArrayCheck from "@utils/isArray";
import { fetchDeliveryRating } from "@services/api";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { SHOP_PERFORMANCE_EVENTS } from "@constants/analyticsEventsCT";
import color from "@constants/color";
import RatingCard from "./RatingCard";

const PATH = "screens/RatingInfo";

const RatingInfo = (props) => {
  const { navigation } = props;
  const route = useRoute();
  const [ratingData, setRatingData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getRatingData();
    analytics.trackEvent(SHOP_PERFORMANCE_EVENTS.RATING_PAGE_LANDED);
  }, []);

  const getRatingData = async () => {
    try {
      const currentRatingResponse = await fetchDeliveryRating("CURRENT");
      setRatingData(currentRatingResponse?.data);
      setIsLoading(false);
      const previousRatingResponse = await fetchDeliveryRating("PREVIOUS");

      if (previousRatingResponse?.data) {
        setRatingData((prev) => ({
          ...prev,
          monthwise_rating_summary: [
            ...prev?.monthwise_rating_summary,
            ...previousRatingResponse?.data?.monthwise_rating_summary,
          ],
        }));
      }
    } catch (error) {
      console.log("Error : ", error);
    }
  };
  const renderData = (item, index) => (
    <View
      key={index}
      style={[
        styles.card,
        { backgroundColor: item?.bgColor || "rgba(0, 171, 89, 0.08)" },
      ]}
    >
      <Text style={styles.cardText}>{item?.desc}</Text>
    </View>
  );

  return (
    <View style={styles.container}>
      <HeaderWithBackAndTitle
        headerColor="#fff"
        headertitle={t(`${PATH}/header`)}
        navigation={navigation}
        route={route}
        hideShadow={true}
        isTransparent={false}
        headerStyle={styles.headerStyle}
        rightComponent={
          <View style={styles.rightComponent}>
            <ProfileIcon width={24} height={24} bgOpacity={0.3} opacity={1} />
            <Text
              style={{
                color: "#000",
                fontSize: 16,
                fontWeight: "700",
                marginHorizontal: s.xs,
              }}
            >
              {ratingData?.monthwise_rating_summary?.[0]?.overall_rating || 0}
            </Text>
            <GoldenStar fill="#FFB800" />
          </View>
        }
      />
      {isLoading ? (
        <View style={styles.loaderContainer}>
          <ActivityIndicator size="large" color={color.primary} />
        </View>
      ) : (
        <ScrollView
          style={{ marginHorizontal: s.m }}
          contentContainerStyle={{ flexGrow: 1 }}
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.mainContainer}>
            <RNCarousel
              bullets={true}
              bulletStyle={styles.bullet}
              chosenBulletStyle={styles.chosenBullet}
              bulletsContainerStyle={styles.bulletsContainer}
              style={styles.carousel}
              autoplay={true}
              delay={3000}
              pageInfo={false}
            >
              {ratingData?.carousel?.map(renderData)}
            </RNCarousel>

            {isArrayCheck(ratingData?.monthwise_rating_summary).map((item, index) => (
              <RatingCard key={item.header_text ?? index} summary={item} />
            ))}
          </View>
        </ScrollView>
      )}
    </View>
  );
};

export default RatingInfo;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#fff",
    flex: 1,
  },
  card: {
    borderRadius: 16,
    padding: s.xxl,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    overflow: "hidden",
    marginHorizontal: s.m,
  },
  cardText: {
    fontSize: 18,
    fontFamily: "Noto Sans Devanagari",
    color: "#6A6A6A",
    fontWeight: "700",
  },
  headerStyle: {
    fontSize: 18,
    marginBottom: s.xs,
  },
  rightComponent: {
    flexDirection: "row",
  },
  mainContainer: {
    marginHorizontal: s.m,
    marginBottom: s.xxl,
  },
  bullet: {
    height: s.s,
    width: s.s,
    backgroundColor: "#D9D9D9",
    borderRadius: 50,
    marginHorizontal: 3,
    borderWidth: 0,
  },
  chosenBullet: {
    height: s.s,
    width: s.xxl,
    backgroundColor: "rgba(228, 0, 70, 1)",
    borderRadius: 50,
    marginHorizontal: 3,
    borderWidth: 0,
  },
  bulletsContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    top: 90,
  },
  carousel: {
    height: 90,
    marginVertical: s.m,
    justifyContent: "center",
    marginBottom: 36,
  },
  loaderContainer: {
    flex: 1,
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
});
